import React from "react";
import { createPortal } from "react-dom";
import { AnimatePresence } from "framer-motion";
import { FaTimes } from "react-icons/fa";
import {
  RightDrawerIconButton,
  RightDrawerHeaderRow,
  RightDrawerTextGroup,
  RightDrawerScrollArea,
  RightDrawerSectionHeading,
  RightDrawerOverlayMotionButton,
  RightDrawerMotionPanel,
  RightDrawerEyebrowText,
} from "components/global/styles/RightDrawer.inline.styles";

interface RightDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
}

const RightDrawer: React.FC<RightDrawerProps> = ({
  isOpen,
  onClose,
  title = "Editor",
  children,
}) => {
  if (typeof document === "undefined") {
    return null;
  }

  return createPortal(
    <AnimatePresence>
      {isOpen ? (
        <>
          <RightDrawerOverlayMotionButton
            aria-label="Close editor overlay"
            exit={{
              opacity: 0,
            }}
            initial={{
              opacity: 0,
            }}
            animate={{
              opacity: 1,
            }}
            onClick={onClose}
          />

          <RightDrawerMotionPanel
            exit={{
              x: "100%",
            }}
            initial={{
              x: "100%",
            }}
            animate={{
              x: 0,
            }}
            transition={{
              type: "spring",
              damping: 28,
              stiffness: 260,
            }}
          >
            <RightDrawerHeaderRow>
              <RightDrawerTextGroup>
                <RightDrawerEyebrowText>Editor</RightDrawerEyebrowText>
                <RightDrawerSectionHeading>{title}</RightDrawerSectionHeading>
              </RightDrawerTextGroup>
              <RightDrawerIconButton onClick={onClose} type="button">
                <FaTimes />
              </RightDrawerIconButton>
            </RightDrawerHeaderRow>

            <RightDrawerScrollArea>{children}</RightDrawerScrollArea>
          </RightDrawerMotionPanel>
        </>
      ) : null}
    </AnimatePresence>,
    document.body,
  );
};

export default RightDrawer;
